import React from 'react'

const RetrocessionStyle = () => {
    return (
        <style>{`
                :root {
                    --retro-primary: #1a365d;
                    --retro-primary-light: #2d5a87;
                    --retro-accent: #ed8936;
                    --retro-success: #48bb78;
                    --retro-warning: #ecc94b;
                    --retro-danger: #f56565;
                    --retro-info: #4299e1;
                    --retro-bg: #f7fafc;
                    --retro-card-bg: #ffffff;
                    --retro-border: #e2e8f0;
                    --retro-text: #2d3748;
                    --retro-text-muted: #718096;
                    --retro-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
                    --retro-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
                }

                /* Header principal */
                .retrocession-page-header {
                    background: linear-gradient(135deg, var(--retro-primary) 0%, var(--retro-primary-light) 100%);
                    border-radius: 16px;
                    padding: 32px 40px;
                    margin-bottom: 28px;
                    box-shadow: var(--retro-shadow-lg);
                    position: relative;
                    overflow: hidden;
                }

                .retrocession-page-header::before {
                    content: '';
                    position: absolute;
                    top: -50%;
                    right: -5%;
                    width: 400px;
                    height: 400px;
                    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
                    border-radius: 50%;
                }

                .retrocession-page-header h1 {
                    color: white;
                    font-size: 32px;
                    font-weight: 700;
                    margin: 0 0 8px 0;
                    position: relative;
                    z-index: 1;
                }

                .retrocession-page-header p {
                    color: rgba(255,255,255,0.85);
                    font-size: 15px;
                    margin: 0;
                    position: relative;
                    z-index: 1;
                }

                /* Filtres */
                .filter-card {
                    background: var(--retro-card-bg);
                    border-radius: 12px;
                    border: 1px solid var(--retro-border);
                    box-shadow: var(--retro-shadow);
                    transition: all 0.3s ease;
                    height: 100%;
                }

                .filter-card:hover {
                    box-shadow: var(--retro-shadow-lg);
                    border-color: var(--retro-primary);
                }

                .filter-card .card-body {
                    padding: 20px;
                }

                .filter-label {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 13px;
                    font-weight: 600;
                    color: var(--retro-text);
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-bottom: 12px;
                }

                .filter-label .anticon {
                    color: var(--retro-primary);
                }

                /* Carte principale */
                .main-card {
                    background: var(--retro-card-bg);
                    border-radius: 16px;
                    box-shadow: var(--retro-shadow-lg);
                    overflow: hidden;
                }

                .main-card-header {
                    background: linear-gradient(90deg, var(--retro-primary) 0%, var(--retro-primary-light) 100%);
                    padding: 24px 32px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .main-card-header h2 {
                    color: white;
                    font-size: 20px;
                    font-weight: 600;
                    margin: 0;
                }

                .status-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    background: rgba(72, 187, 120, 0.9);
                    color: white;
                    padding: 8px 16px;
                    border-radius: 20px;
                    font-size: 13px;
                    font-weight: 600;
                }

                /* Tabs personnalisés */
                .retro-tabs .ant-tabs-nav {
                    background: var(--retro-bg);
                    padding: 12px;
                    border-radius: 12px;
                    margin: 0 0 24px 0;
                }

                .retro-tabs .ant-tabs-tab {
                    padding: 12px 20px;
                    margin: 0 6px;
                    border-radius: 8px;
                    transition: all 0.3s ease;
                    background: transparent;
                    border: none;
                }

                .retro-tabs .ant-tabs-tab:hover {
                    background: rgba(26, 54, 93, 0.08);
                }

                .retro-tabs .ant-tabs-tab-active {
                    background: var(--retro-primary) !important;
                }

                .retro-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
                    color: white !important;
                }

                .retro-tabs .ant-tabs-ink-bar {
                    display: none;
                }

                .tab-icon-validated {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 20px;
                    height: 20px;
                    background: var(--retro-success);
                    color: white;
                    border-radius: 50%;
                    font-size: 11px;
                    margin-left: 8px;
                }

                /* Bordereau container */
                .bordereau-container {
                    padding: 0;
                }

                .bordereau-header {
                    background: var(--retro-card-bg);
                    border-left: 4px solid;
                    border-radius: 12px;
                    padding: 24px;
                    margin-bottom: 24px;
                    box-shadow: var(--retro-shadow);
                }

                .bordereau-header .header-content {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 20px;
                }

                .bordereau-header .title-section {
                    display: flex;
                    align-items: flex-start;
                    gap: 16px;
                }

                .bordereau-header .type-icon {
                    font-size: 28px;
                    margin-top: 4px;
                }

                .bordereau-header h3 {
                    font-size: 20px;
                    font-weight: 700;
                    color: var(--retro-text);
                    margin: 0 0 6px 0;
                }

                .bordereau-header p {
                    font-size: 14px;
                    color: var(--retro-text-muted);
                    margin: 0;
                }

                .global-summary {
                    padding: 20px 24px;
                    border-radius: 10px;
                    margin-top: 16px;
                }

                .global-summary .ant-statistic-title {
                    font-size: 12px;
                    color: var(--retro-text-muted);
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .global-summary .ant-statistic-content {
                    font-size: 22px;
                }

                /* Collapse compagnie */
                .compagnie-collapse {
                    background: transparent;
                    border: none;
                }

                .compagnie-collapse .ant-collapse-item {
                    background: var(--retro-card-bg);
                    border: 1px solid var(--retro-border);
                    border-radius: 12px !important;
                    margin-bottom: 12px;
                    overflow: hidden;
                    transition: all 0.3s ease;
                }

                .compagnie-collapse .ant-collapse-item:hover {
                    border-color: var(--retro-primary);
                    box-shadow: var(--retro-shadow);
                }

                .compagnie-collapse .ant-collapse-item-active {
                    border-color: var(--retro-primary);
                    box-shadow: var(--retro-shadow-lg);
                }

                .compagnie-collapse .ant-collapse-header {
                    padding: 16px 20px !important;
                    align-items: center !important;
                }

                .compagnie-collapse .ant-collapse-content {
                    border-top: 1px solid var(--retro-border);
                }

                .compagnie-collapse .ant-collapse-content-box {
                    padding: 20px;
                }

                /* Panel header personnalisé */
                .compagnie-panel-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    padding-right: 12px;
                }

                .compagnie-panel-header .header-left {
                    display: flex;
                    align-items: center;
                }

                .compagnie-panel-header .compagnie-info {
                    display: flex;
                    flex-direction: column;
                }

                .compagnie-panel-header .compagnie-name {
                    font-size: 15px;
                    font-weight: 600;
                    color: var(--retro-text);
                }

                .compagnie-panel-header .compagnie-code {
                    font-size: 12px;
                    color: var(--retro-text-muted);
                }

                .compagnie-panel-header .header-right {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                }

                .compagnie-panel-header .stat-item {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                }

                .compagnie-panel-header .stat-label {
                    font-size: 11px;
                    color: var(--retro-text-muted);
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .compagnie-panel-header .stat-value {
                    font-size: 14px;
                    font-weight: 600;
                    color: var(--retro-text);
                }

                .compagnie-panel-header .stat-item.highlight .stat-value {
                    font-size: 16px;
                    font-weight: 700;
                }

                /* Table summary row */
                .summary-row {
                    background: var(--retro-bg) !important;
                }

                .summary-row td {
                    background: var(--retro-bg) !important;
                    border-top: 2px solid var(--retro-border);
                }

                /* Footer bordereau */
                .bordereau-footer {
                    display: flex;
                    justify-content: flex-end;
                    padding: 24px 0;
                    margin-top: 24px;
                    border-top: 1px solid var(--retro-border);
                }

                /* Récapitulatif global */
                .recap-container {
                    padding: 24px;
                }

                .recap-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 20px;
                    margin-bottom: 32px;
                }

                .recap-card {
                    background: var(--retro-card-bg);
                    border-radius: 12px;
                    padding: 24px;
                    border: 1px solid var(--retro-border);
                    transition: all 0.3s ease;
                }

                .recap-card:hover {
                    box-shadow: var(--retro-shadow);
                }

                .recap-card-header {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 16px;
                }

                .recap-card-icon {
                    width: 48px;
                    height: 48px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 22px;
                }

                .recap-card-title {
                    font-size: 14px;
                    color: var(--retro-text-muted);
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .recap-card-value {
                    font-size: 28px;
                    font-weight: 700;
                    line-height: 1.2;
                }

                .recap-total-card {
                    background: linear-gradient(135deg, var(--retro-primary) 0%, var(--retro-primary-light) 100%);
                    color: white;
                    border: none;
                }

                .recap-total-card .recap-card-title {
                    color: rgba(255,255,255,0.8);
                }

                .recap-total-card .recap-card-value {
                    color: white;
                }

                /* Tableau de suivi compagnies */
                .tracking-card {
                    background: var(--retro-card-bg);
                    border-radius: 12px;
                    border: 1px solid var(--retro-border);
                    box-shadow: var(--retro-shadow);
                    margin-bottom: 28px;
                }

                .tracking-card .ant-card-head {
                    background: var(--retro-bg);
                    border-bottom: 1px solid var(--retro-border);
                    border-radius: 12px 12px 0 0;
                }

                .tracking-card .ant-card-head-title {
                    font-weight: 600;
                    color: var(--retro-text);
                }

                .global-bordereau-card .ant-card-head {
                    background: linear-gradient(135deg, #f8fafc 0%, #edf2f7 100%);
                    border-bottom: 2px solid var(--retro-border);
                }

                .global-bordereau-card .ant-table-thead > tr > th {
                    background: #f0f5ff !important;
                    font-weight: 600;
                    font-size: 12px;
                }

                .global-bordereau-card .even-row {
                    background: #fafafa;
                }

                .global-bordereau-card .odd-row {
                    background: #ffffff;
                }

                .global-bordereau-card .even-row:hover td,
                .global-bordereau-card .odd-row:hover td {
                    background: #e6f7ff !important;
                }

                .global-bordereau-card .summary-row td {
                    background: #f0f5ff !important;
                    border-top: 2px solid var(--retro-primary) !important;
                }

                /* Responsive */
                @media (max-width: 992px) {
                    .compagnie-panel-header {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 16px;
                    }

                    .compagnie-panel-header .header-right {
                        width: 100%;
                        justify-content: space-between;
                    }

                    .bordereau-header .header-content {
                        flex-direction: column;
                        gap: 16px;
                    }
                }

                @media (max-width: 768px) {
                    .retrocession-page-header {
                        padding: 24px;
                    }

                    .retrocession-page-header h1 {
                        font-size: 24px;
                    }

                    .main-card-header {
                        flex-direction: column;
                        gap: 12px;
                        align-items: flex-start;
                    }
                }
            `}</style>
    )
}

export default RetrocessionStyle